import React, { useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { cpp } from "@codemirror/lang-cpp"; // use cpp mode for C as well

const CProgrammingCodeEditorTerminal = () => {
  const [code, setCode] = useState(
    `#include <stdio.h>
int main() {
  printf("Hello from C\\n");
  return 0;
}`
  );
  const [output, setOutput] = useState("");

  const runCode = () => {
    setOutput(
      "⚠️ C execution not supported in React-only. Needs WebAssembly/Emscripten."
    );
  };

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div style={{ flex: 1, position: "relative" }}>
        <button
          onClick={runCode}
          style={{
            position: "absolute",
            top: "10px",
            right: "30px",
            zIndex: 10,
            padding: "10px 20px",
            background: "#333",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Run ▶
        </button>
        <CodeMirror
          value={code}
          height="82vh"
          extensions={[cpp()]}
          onChange={setCode}
        />
      </div>
      <div
        style={{
          flex: 1,
          background: "#1e1e1e",
          color: "#fff",
          padding: "10px",
        }}
      >
        <h4>Output:</h4>
        <pre>{output}</pre>
      </div>
    </div>
  );
};

export default CProgrammingCodeEditorTerminal;
